import { fabric } from 'fabric';
import urlHelper from '../../frontend/services/helpers/url';
import { ADDITIONAL_ICONS_PREFIX_ID, ICONS_PREFIX_ID } from "@frontend/constants/templates-field-prefixes";

export const ICONS_DATA_FIELD = 'icons';
export const ADDITIONAL_ICONS_DATA_FIELD = 'add_icons';

const PLACEMENT_ORDER = {
  ASC: 'asc',
  DEC: 'dec',
}

const PLACEMENT_ORIENTATION = {
  RIGHT_TO_LEFT: 'rightToLeft',
  LEFT_TO_RIGHT: 'leftToRight',
  UP_TO_DOWN: 'upToDown',
  DOWN_TO_UP: 'downToUp',
}

function createIconImage(url, options) {
  return new Promise((resolve, reject) => {
    const _url = urlHelper.normalizeImgUrl(url);

    fabric.Image.fromURL(_url, (img) => {
      if (!img) {
        return reject(new Error(`Failed to load image: ${url}`));
      }

      const originalWidth = img.width;

      const targetWidth = options.width;

      const scale = targetWidth / originalWidth;

      img.set({
        id: options.id,
        element_id: options.element_id,
        name: options.name,
        top: options.top,
        left: options.left,
        scaleX: scale,
        scaleY: scale,
        opacity: options.opacity,
        order: options.order,
      });
      
      resolve(img);
    });
  });
}

async function prepareIconsGroups(icons, prefix) {
  const iconGroups = [];

  for (let iconsField = 0; iconsField < icons.length; iconsField++) {
    const { id, elements, touched, placementOrder, placementOrientation } = icons[iconsField];
    
    if (!elements?.length) {
      continue;
    }
    
    const _elements = [...elements];
    let iconImages = [];
    
    if (placementOrder === PLACEMENT_ORDER.DEC) {
      _elements.reverse();
    }

    let left;
    let top;
    let spacing = 10;

    for (let i = 0; i < _elements.length; i++) {
      const options = _elements[i];

      if (touched || !touched && i === 0) {
        left = options.left;
        top = options.top;
      }

      const iconImage = await createIconImage(options.url, {
        id: `${prefix}${id}_${i}`,
        element_id: `${prefix}${id}_${i}`,
        name: `${prefix}${id}_${i}`,
        top: Number(top),
        left: Number(left),
        width: Number(options.width),
        height: Number(options.height),
        opacity: Number(options.opacity) || 1,
        order: Number(options.order)
      });

      iconImages.push(iconImage);
      
      switch (placementOrientation) {
        case PLACEMENT_ORIENTATION.LEFT_TO_RIGHT:
          left += options.width + spacing;
          break;
          
        case PLACEMENT_ORIENTATION.RIGHT_TO_LEFT:
          left -= options.width + spacing;
          break;
          
        case PLACEMENT_ORIENTATION.UP_TO_DOWN:
          top += options.height + spacing;
          break;

        case PLACEMENT_ORIENTATION.DOWN_TO_UP:
          top -= options.height + spacing;
          break;
          
        default:
          left += options.width + spacing;
      }
    }

    const group = new fabric.Group(iconImages, { 
      id: `${prefix}${id}`,
    });
    
    iconGroups.push(group);
    iconImages = [];
  }

  return iconGroups;
}

export async function drawIcons({ canvas, data }) {
  try {
    canvas.getObjects().forEach(function (o) {
      if (o.id.startsWith(ICONS_PREFIX_ID)) {
        canvas.remove(o);
      }
    });

    if (!data.icons?.length) return;

    const iconGroups = await prepareIconsGroups(data.icons, ICONS_PREFIX_ID);
    
    iconGroups.forEach(group => canvas.add(group));
  } catch (error) {
    console.log('An error occurred in the drawIcons method: ', error);
  }
  
}

export async function drawAdditionalIcons({canvas, data}) {
  canvas.getObjects().forEach(function (o) {
    if (o.id.startsWith(ADDITIONAL_ICONS_PREFIX_ID)) {
      canvas.remove(o);
    }
  });

  if (!data[ADDITIONAL_ICONS_DATA_FIELD]?.length) return;

  const iconGroups = await prepareIconsGroups(data[ADDITIONAL_ICONS_DATA_FIELD], ADDITIONAL_ICONS_PREFIX_ID);

  iconGroups.forEach(group => canvas.add(group));
}

